"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Separator = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Placeholder = function Placeholder(props) {
    return _react2.default.createElement(_Item2.default, (0, _extends3.default)({}, props, { placeholder: true }));
};

exports.default = Placeholder;
var Separator = exports.Separator = function Separator(props) {
    return null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-detail@0.0.6@@alicd/crui-detail/lib/Placeholder.js
// module id = 631
// module chunks = 0